/**
 * Icon button variant constants
 */
export const ICON_BUTTON_VARIANTS = {
  FILLED: 'filled',
  OUTLINED: 'outlined',
  TONAL: 'tonal',
  PLAIN: 'plain',
} as const

/**
 * Icon button size constants
 */
export const ICON_BUTTON_SIZES = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
} as const

/**
 * Icon button color constants (only for plain variant)
 */
export const ICON_BUTTON_COLORS = {
  PRIMARY: 'primary',
  NEUTRAL: 'neutral',
  BLACK: 'black',
} as const

/** Sizes supported by plain variant (xs not available) */
export const PLAIN_VALID_SIZES = [ICON_BUTTON_SIZES.SM, ICON_BUTTON_SIZES.MD, ICON_BUTTON_SIZES.LG] as const
